import React, { useEffect, useState } from 'react';
import { db } from "../firebaseConfig.js";
import {
    collection,
    addDoc,
    onSnapshot,
    query,
    orderBy,
    Timestamp,
} from 'firebase/firestore';
import * as XLSX from 'xlsx';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ClearIcon from '@mui/icons-material/Clear';
import emailjs from 'emailjs-com';
import { doc, updateDoc } from "firebase/firestore";

const SupplierLedger = () => {
    const [entries, setEntries] = useState([]);
    const [form, setForm] = useState({
        supplier: '',
        folder: '',
        voucher: '',
        passenger: '',
        item: '',
        cost: '',
        paid: '',
    });

    const [form2, setForm2] = useState({
        supplier: '',
        folder: '',
        voucher: '',
        passenger: '',
        item: '',
        cost: '',
        paid: '',
    });

    const [filters, setFilters] = useState({
        supplier: '',
        startDate: '',
        endDate: '',
    });

    const suppliers = ['Asdaf', 'Arabian', 'Muhabiya', 'Rowa', 'Assabir',
        'Aston', 'Aden', 'Emaar', 'Daniyal', 'Al Subiyee', 'GM Travel', 'Basma',
        'Hassan Kamran'
    ];

    useEffect(() => {
        const q = query(collection(db, 'ledgerEntries'), orderBy('timestamp', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetched = snapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    timestamp: data.timestamp?.toDate?.() ?? new Date(),
                };
            });
            setEntries(fetched);
        });

        return () => unsubscribe();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleChange2 = (e) => {
        const { name, value } = e.target;
        setForm2((prev) => ({ ...prev, [name]: value }));
    };



    const handleAddEntry = async () => {
        if (!form.cost && !form.paid) return alert('Enter cost or paid amount.');
        if (!form.supplier) return alert('Select a supplier.');

        const newEntry = {
            supplier: form.supplier,
            folder: form.folder || '-',
            voucher: form.voucher || '-',
            passenger: form.passenger || '-',
            item: form.item || '-',
            cost: parseFloat(form.cost || 0),
            paid: parseFloat(form.paid || 0),
            timestamp: Timestamp.now(),
        };

        try {
            await addDoc(collection(db, 'ledgerEntries'), newEntry);
            setForm({
                supplier: '',
                folder: '',
                voucher: '',
                passenger: '',
                item: '',
                cost: '',
                paid: '',
            });
        } catch (error) {
            console.error('Error adding document: ', error);
            alert('Failed to add entry.');
        }
    };

    const filteredEntries = entries.filter((entry) => {
        const entryDate = new Date(entry.timestamp);
        const matchesSupplier = filters.supplier ? entry.supplier === filters.supplier : true;
        const matchesStart =
            filters.startDate ? entryDate >= new Date(filters.startDate) : true;
        const matchesEnd =
            filters.endDate ? entryDate <= new Date(filters.endDate) : true;
        return matchesSupplier && matchesStart && matchesEnd;
    });

    const totalCost = filteredEntries.reduce((sum, e) => sum + e.cost, 0);
    const totalPaid = filteredEntries.reduce((sum, e) => sum + e.paid, 0);
    const balance = totalCost - totalPaid;


    const handleExportExcel = () => {
        if (!filteredEntries.length) return alert("No data to export.");

        const dataToExport = filteredEntries.map(entry => ({
            Supplier: entry.supplier,
            'Folder #': entry.folder,
            'Voucher #': entry.voucher,
            'Passenger Name': entry.passenger,
            'Item Name': entry.item,
            Cost: entry.cost,
            Paid: entry.paid,
            Date: new Date(entry.timestamp).toLocaleDateString(),
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Supplier Ledger");

        XLSX.writeFile(workbook, "SupplierLedger.xlsx");
    };

    const [EditBool, setEditBool] = useState(false);
    const [editId, setEditId] = useState(null);

    const [Otp, setOtp] = useState('');

    const [OtpEntered, setOtpEntered] = useState('');

    const handleChangeOtp = (e) => {
        setOtpEntered(e.target.value);
    };



    function EditClicked(id) {
        const selected = entries.find(e => e.id === id);
        if (!selected) return;

        setForm2({
            supplier: selected.supplier,
            folder: selected.folder,
            voucher: selected.voucher,
            passenger: selected.passenger,
            item: selected.item,
            cost: selected.cost,
            paid: selected.paid,
        });

        setEditId(id);
        setEditBool(true);
        sendOTPEmail()
    }

    function CloseEdit() {
        setEditBool(false)
        setOtp('')
    }


    const handleUpdateEntry = async () => {
        if (!editId) return;

        if (Otp !== OtpEntered) {
            alert(`Otp is not correct`);
            return;
        }

        const updatedEntry = {
            supplier: form2.supplier,
            folder: form2.folder || '-',
            voucher: form2.voucher || '-',
            passenger: form2.passenger || '-',
            item: form2.item || '-',
            cost: parseFloat(form2.cost || 0),
            paid: parseFloat(form2.paid || 0),
        };

        try {
            const entryRef = doc(db, "ledgerEntries", editId);
            await updateDoc(entryRef, updatedEntry);

            setEditBool(false);
            setEditId(null);
            alert(`Document Updated`);
            setOtpEntered('')
        } catch (error) {
            console.error("Error updating entry: ", error);
            alert("Failed to update entry.");
        }
    };


    // Generate random 6-digit OTP
    const generateOTP = async () => {
        const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let otp = '';
        for (let i = 0; i < 6; i++) {
            otp += chars[Math.floor(Math.random() * chars.length)];
        }
        setOtp(otp);
        return otp;
    };


    // Send OTP via EmailJS
    async function sendOTPEmail() {
        const otp = await generateOTP();

        const templateParams = {
            passcode: otp, // matches {{passcode}} in your EmailJS template
        };

        try {
            const result = await emailjs.send(
                'service_b6ndgpj',
                'template_ddgixgh',
                templateParams,
                'uBLPVWCBu6ybsZ6fk' // or 'YOUR_PUBLIC_KEY' from EmailJS dashboard
            );

            return otp; // return the OTP so you can verify it on the frontend
        } catch (error) {
            console.error('EmailJS Error:', error);
            throw error;
        }
    }



    return (
        <div style={{ padding: '2rem', maxWidth: '1100px', margin: '0 auto' }}>
            <h2>Supplier Ledger</h2>

            {/* Entry Form */}
            <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                <select name="supplier" value={form.supplier} onChange={handleChange}>
                    <option value="">Select Supplier</option>
                    {suppliers.map((sup, idx) => (
                        <option key={idx} value={sup}>
                            {sup}
                        </option>
                    ))}
                </select>
                <input name="folder" placeholder="Folder #" value={form.folder} onChange={handleChange} />
                <input name="voucher" placeholder="Voucher #" value={form.voucher} onChange={handleChange} />
                <input name="passenger" placeholder="Passenger Name" value={form.passenger} onChange={handleChange} />
                <input name="item" placeholder="Item Name" value={form.item} onChange={handleChange} />
                <input name="cost" placeholder="Cost(SAR)" type="number" value={form.cost} onChange={handleChange} />
                <input name="paid" placeholder="Paid(SAR)" type="number" value={form.paid} onChange={handleChange} />
                <button onClick={handleAddEntry}>Add Entry</button>
            </div>

            {/* Filters */}
            <div style={{ margin: '1rem 0', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <select
                    value={filters.supplier}
                    onChange={(e) => setFilters((prev) => ({ ...prev, supplier: e.target.value }))}
                >
                    <option value="">Filter by Supplier</option>
                    {suppliers.map((sup, idx) => (
                        <option key={idx} value={sup}>
                            {sup}
                        </option>
                    ))}
                </select>
                <input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => setFilters((prev) => ({ ...prev, startDate: e.target.value }))}
                />
                <input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) => setFilters((prev) => ({ ...prev, endDate: e.target.value }))}
                />
            </div>


            <button onClick={handleExportExcel} style={{ marginBottom: '1rem' }}>
                Export to Excel
            </button>
            {/* Ledger Table */}
            <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th>Sr.</th>
                        <th>Supplier</th>
                        <th>Folder #</th>
                        <th>Voucher #</th>
                        <th>Passenger Name</th>
                        <th>Item Name</th>
                        <th>Cost(SAR)</th>
                        <th>Paid(SAR)</th>
                        <th>Date</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEntries.map((entry, index) => (
                        <tr key={entry.id}
                            //  key={entry.id}
                            style={{
                                backgroundColor: entry.paid > 0 ? 'yellow' : 'transparent' // light green
                            }}>
                            <td>{index + 1}</td>
                            <td>{entry.supplier}</td>
                            <td>{entry.folder}</td>
                            <td>{entry.voucher}</td>
                            <td>{entry.passenger}</td>
                            <td>{entry.item}</td>
                            <td>{entry.cost.toLocaleString()}</td>
                            <td>{entry.paid.toLocaleString()}</td>
                            <td>{new Date(entry.timestamp).toLocaleDateString()}</td>
                            <td onClick={() => EditClicked(entry.id)}><ModeEditIcon style={{ color: "red" }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ marginTop: '1rem' }}>
                <strong>Total Cost (SAR):</strong> {totalCost.toLocaleString()} <br />
                <strong>Total Paid (SAR):</strong> {totalPaid.toLocaleString()} <br />
                <strong>Remaining Balance (SAR):</strong> {balance.toLocaleString()}
            </div>

            {EditBool &&
                <div style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    height: '150px',
                    width: "70%",
                    backgroundColor: "white",  // optional
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",  // optional
                    padding: "20px",  // optional
                    zIndex: 1000  // ensures it stays on top
                }}>
                    <ClearIcon style={{ position: "absolute", right: "15px", top: "10px" }} onClick={() => CloseEdit()} />

                    <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        <select name="supplier" value={form2.supplier} onChange={handleChange2}>
                            <option value="">Select Supplier</option>
                            {suppliers.map((sup, idx) => (
                                <option key={idx} value={sup}>
                                    {sup}
                                </option>
                            ))}
                        </select>
                        <input name="folder" placeholder="Folder #" value={form2.folder} onChange={handleChange2} />
                        <input name="voucher" placeholder="Voucher #" value={form2.voucher} onChange={handleChange2} />
                        <input name="passenger" placeholder="Passenger Name" value={form2.passenger} onChange={handleChange2} />
                        <input name="item" placeholder="Item Name" value={form2.item} onChange={handleChange2} />
                        <input name="cost" placeholder="Cost(SAR)" type="number" value={form2.cost} onChange={handleChange2} />
                        <input name="paid" placeholder="Paid(SAR)" type="number" value={form2.paid} onChange={handleChange2} />
                        <input name="otp" placeholder="OTP" value={OtpEntered}
                            onChange={handleChangeOtp} />
                        <button onClick={handleUpdateEntry}>Update Entry</button>
                    </div>
                </div>
            }



        </div>
    );
};

export default SupplierLedger;
